export default __webpack_public_path__ + "static/media/cameliascreaming.d53b3fab.jpg";